// 财务管理
const finance = [
  {
    path: '/pay-order',
    name: 'payOrderPage',
    meta: { tag: '订单支付记录' },
    component: () => import('@/pages/PayOrderPage')
  },
  {
    path: '/service-fee',
    name: 'serviceFeePage',
    meta: { tag: '劳务费结算记录-跑步机' },
    component: () => import('@/pages/PmpRecordPage/serviceFee')
  },
  {
    path: '/bill',
    name: 'billPage',
    meta: { tag: '开票申请记录' },
    component: () => import('@/pages/BillPage')
  },
  {
    path: '/wait-confirm-push-sap-pmp',
    name: 'pmpRecordPushSapPage',
    meta: { tag: '待确认推送SAP工单-返修工单' },
    component: () => import('@/pages/PmpRecordPushSap')
  },
  {
    path: '/wait-confirm-push-sap-order',
    name: 'orderRecordPushSapPage',
    meta: { tag: '待确认推送SAP工单-订单记录' },
    component: () => import('@/pages/OrderRecordPushSap')
  },
  {
    path: '/record-push-sap',
    name: 'recordPushSapPage',
    meta: { tag: '返修、订单推送SAP记录' },
    component: () => import('@/pages/RecordPushSapPage')
  },
  {
    path: '/mi-return-record',
    name: 'miReturnRecordPage',
    meta: { tag: '小米批量退回工单' },
    component: () => import('@/pages/MiReturnRecordPage/index')
  },
  {
    path: '/push-agent-order-record',
    name: 'pushAgentOrderRecordPage',
    meta: { tag: '京东/样机退货工单' },
    component: () => import('@/pages/PushAgentOrderRecordPage/index')
  },
  {
    path: '/pmp-record-factory-service-fee',
    name: 'pmpRecordFactoryServiceFeeIndexPage',
    meta: { tag: '劳务费结算记录-返修' },
    component: () => import('@/pages/PmpRecordPage/factoryServiceFeeIndex')
  },
  {
    path: '/order-record-factory-service-fee',
    name: 'orderRecordFactoryServiceFeeIndexPage',
    meta: { tag: '劳务费结算记录-订单' },
    component: () => import('@/pages/OrderRecordFactoryServiceFee')
  }
]

export default finance
